import React, { useState, useEffect } from "react";
import styles from "./StatProspect.module.sass";
import cn from "classnames";
import Card from "../../../components/Card";
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from "recharts";
import { getAttendanceStats } from "../../../services/sessionDashboard.service"; 

const defaultData = [
  { name: "Présent", value: 0 },
  { name: "Absent", value: 0 },
];
const COLORS = ["#B5E4CA", "#FFCC5C"];

const StatProspect = ({ className }) => {
  const [loading, setLoading] = useState(true);
  const [attendanceData, setAttendanceData] = useState(defaultData);
  const [percentages, setPercentages] = useState([
    { title: "Présent", percent: 0, fill: "#B5E4CA" }, 
    { title: "Absent", percent: 0, fill: "#FFCC5C" },
  ]);
  
  useEffect(() => {
    const fetchAttendanceStats = async () => { 
      try {
        setLoading(true);
        const stats = await getAttendanceStats(); 
        
        if (stats && stats.total > 0) {
          const data = [
            { name: "Présent", value: stats.presences },
            { name: "Absent", value: stats.absences }
          ];
          setAttendanceData(data);
          
          const total = stats.total;
          const updatedPercentages = [
            { title: "Présent", percent: Math.round((stats.presences / total) * 100), fill: "#B5E4CA" },
            { title: "Absent", percent: Math.round((stats.absences / total) * 100), fill: "#FFCC5C" }
          ];
          setPercentages(updatedPercentages);
        } else {
          setAttendanceData(defaultData);
          setPercentages([
            { title: "Présent", percent: 0, fill: "#B5E4CA" },
            { title: "Absent", percent: 0, fill: "#FFCC5C" }
          ]);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des statistiques d\'attendance:', error);
        setAttendanceData(defaultData); 
        setPercentages([
          { title: "Présent", percent: 0, fill: "#B5E4CA" },
          { title: "Absent", percent: 0, fill: "#FFCC5C" }
        ]); 
      } finally {
        setLoading(false);
      }
    };
    
    fetchAttendanceStats(); 
  }, []); 

  return (
    <Card
      className={cn(styles.card, className)}
      title="Taux de présence"
      classTitle="title-yellow"
    >
      <div className={styles.chart}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart width={400} height={400}>
            <Tooltip
              contentStyle={{
                backgroundColor: "#272B30",
                borderColor: "rgba(255, 255, 255, 0.12)",
                borderRadius: 8,
                boxShadow:
                  "0px 4px 8px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.1), inset 0px 0px 1px #000000",
              }}
              labelStyle={{ fontSize: 12, fontWeight: "500", color: "#fff" }}
              itemStyle={{
                padding: 0,
                textTransform: "capitalize",
                fontSize: 12,
                fontWeight: "600",
                color: "#fff",
              }}
              formatter={(value) => [`${value} émargements`, '']}
            />
            <Pie
              data={loading ? defaultData : attendanceData}
              cx={140} 
              cy={110} 
              innerRadius={88}
              outerRadius={110}
              fill="#8884d8"
              paddingAngle={1}
              dataKey="value"
            >
              {(loading ? defaultData : attendanceData).map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className={styles.legend}>
        {percentages.map((x, index) => (
          <div className={styles.indicator} key={index}>
            <div className={styles.title} style={{ color: x.fill }}>{x.title}</div>
            <div className={styles.percent}>{x.percent}%</div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default StatProspect;
